import { useEffect } from "react";
import PropTypes from "prop-types";
import { useSearch } from "../../Contexts/SearchContext";
import "./PopularCategories.scss";
import Button from "../../Button";
import { getActiveFilters, setFilterState } from "../../../helpers";
import { postSearchHandler } from "../../Api";

const PopularCategories = () => {
  const { state, dispatch } = useSearch();
  const { popularCategoriesJson, componentElement, searchTerm } = state;

  /**
   *
   * @param {object} e
   * @returns {void}
   * @description Adds/removes the -isActive class to the clicked filter button.
   * adds/removes the filter from the selectedFilters array in the search context.
   *
   */
  const handleFilter = (e) => {
    let makeActive = e.target.getAttribute("active") !== "true";
    if(makeActive) {
      window.adobeDataLayer?.push({
        event: window.adobeDataLayerEvents?.component.searchFilterApplied,
        filter: {
          category: 'Popular Categories',
          type: 'Product Finder',
          values: e.target.innerHTML
        },
      });
    }
    setFilterState(
      e.currentTarget.parentElement.getAttribute("data-filter"),
      componentElement,
      makeActive,
    );
    dispatch({
      type: "UPDATE_SELECTED_FILTERS",
      payload: getActiveFilters(componentElement),
    });
  };

  return (
    <div className="popular-categories">
      <div className="popular-categories__title">Popular Categories</div>
      <ul className="popular-categories__list">
        {popularCategoriesJson &&
          popularCategoriesJson.map((category) => {
            return (
              <li
                className="popular-categories__item"
                data-filter={category.tagId}
                key={category.tagId}
              >
                <Button
                  variant="tertiary"
                  disabled={false}
                  active={false}
                  onClick={(e) => {
                    handleFilter(e);
                  }}
                >
                  {category.label}
                </Button>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default PopularCategories;
